import compact from 'lodash/compact.js';
import get from 'lodash/get.js';
import join from 'lodash/join.js';

import Model from '@/models/Model.js';

export default class Contact extends Model {
    static entity = 'contacts';

    static modelName = 'Contact';

    static fields() {
        return {
            id: this.attr(null),
            external_id: this.attr(null),
            user_id: this.attr(null),
            first_name: this.attr(null),
            middle_name: this.attr(null),
            last_name: this.attr(null),
            title: this.attr(null),
            email: this.attr(null),
            phone_mobile: this.attr(null),
            phone_work: this.attr(null),
            phone_home: this.attr(null),
            address_1: this.attr(null),
            address_2: this.attr(null),
            city: this.attr(null),
            state: this.attr(null),
            postal_code: this.attr(null),
            country: this.attr(null),

            ...super.fields(),

            user: this.belongsTo('users', 'user_id'),
        };
    }

    get name() {
        return join(compact([this.title, this.first_name, this.middle_name, this.last_name]), ' ');
    }

    get phone() {
        return get(this, 'phone_mobile', get(this, 'phone_work'), get(this, 'phone_home', ''));
    }
}
